/* eslint-disable max-len */
import React from 'react';

const Columns = props => (
  <svg width={19} height={19} {...props}>
    <g stroke="currentColor" fill="none" fillRule="evenodd">
      <rect transform="rotate(90 5.5 9.5)" x={-1.5} y={6.5} width={14} height={6} rx={1} />
      <rect transform="rotate(90 13.5 9.5)" x={6.5} y={6.5} width={14} height={6} rx={1} />
    </g>
  </svg>
);

export default Columns;
